import React, { useEffect, useState } from "react";

import { Button, Modal, ModalDialog } from "react-bootstrap";
import { TextInput, ValidationForm } from "react-bootstrap4-form-validation";
import Draggable from "react-draggable";
import { useReactFlow } from "reactflow";
import ShowMessages from "../../../components/Exceptions";
import api from '../../../services/api'
import Loading from '../../../components/Loading';

class DraggableModalDialog extends React.Component {
    render() {
        return (
            <Draggable handle=".modal-header">
                <ModalDialog {...this.props} />
            </Draggable>
        );
    }
}

export default function ModalTemplateNode({
    nodeId,
    showModal,
    handleCloseModal,
    nodeData,
}) {
    const [loading,setLoading] = useState(false)
    const [templateData, setTemplateData] = useState([])
    const [template, setTemplate] = useState('')
    const [templateSelectData, setTemplateSelectData] = useState([])

    const [category, setCategory] = useState('')
    const [subCategory, setSubCategory] = useState('')
    const [language, setLanguage] = useState('')
    const [status, setStatus] = useState('')
    
    const reactFlowInstance = useReactFlow();

    useEffect(() => {
        setTemplate(nodeData.template)

    }, [nodeData]);

    const handleSubmit = (e) => {
        e.preventDefault();

        reactFlowInstance.setNodes((nds) =>
            nds.map((node) => {
                if (node.id === nodeId) {
                    node.data = {
                        ...node.data,
                        nodeInfo: {
                            node: parseInt(nodeData.node),
                            parentId: parseInt(nodeData.parentId),
                            targetId: parseInt(nodeData.targetId),
                            template,
                            templateSelectData,
                            objectType: 20,
                        },
                    };
                }

                return node;
            })
        );

        handleCloseModal();
    };

    useEffect(() => {
        const _nodes = reactFlowInstance.getNodes()
        const _start = _nodes[0].data.nodeInfo.numberData

        setLoading(true)
        const getData = async () => {
            await api.post('/getAvailableTemplate',{accountID : _start.accountid,token : _start.token})
                .then((response) => {
                    console.log(response.data)
                    setTemplateData(response.data.data)
                }).catch(error => {
                    ShowMessages(error)
                }).finally(() => {
                    setLoading(false)
                })
        }
        getData()
    }, [])

    useEffect(() => {
        const _values = templateData.filter(_item => {
            return _item.name === template
        })
        setTemplateSelectData(_values[0])
        setCategory(_values[0]?.category)
        setSubCategory(_values[0]?.sub_category)
        setLanguage(_values[0]?.language)
        setStatus(_values[0]?.status)
    }, [template])

    return (
        <Modal
            size="md"
            show={showModal}
            onSubmit={handleSubmit}
            onHide={handleCloseModal}
            dialogClassName="maxHeight450 width500"
            animation={true}
            backdrop="static"
            dialogAs={DraggableModalDialog}
        >
            <ValidationForm className="modal-content" setFocusOnError={true}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fa fa-boxes-packing"></i> Template 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading && (
                        <Loading loading={loading} addClass="heigth150px"/>
                    )}
                    {!loading && (
                        <div className="box-shadow" style={{ padding: "10px" }}>
                            <div style={{ display: "flex", width: "100%", gap: "5px" }}>
                                <div style={{ width: '200px' }}>
                                    <span>Template</span>
                                    <select className="form-select" value={template} onChange={e => setTemplate(e.target.value)}>
                                        <option value="">Selecione</option>
                                        {templateData && templateData.map((_item, key) => {
                                            return <option key={key}>{_item.name}</option>
                                        })}
                                    </select>
                                </div>
                                {category && category !== '' && (
                                    <div className="alert alert-primary" style={{ width: "240px" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <span style={{ fontWeight: "bold", fontSize: "12px" }}>Categoria</span>
                                                <span>{category}</span>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <span style={{ fontWeight: "bold", fontSize: "12px" }}>Sub-Categoria</span>
                                                <span>{subCategory}</span>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <span style={{ fontWeight: "bold", fontSize: "12px" }}>Idioma</span>
                                                <span>{language}</span>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <span style={{ fontWeight: "bold", fontSize: "12px" }}>Status</span>
                                                <span>{status}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" id="submit-ia">
                        <em className="fa fa-save"></em> Aplicar
                    </Button>
                    <Button
                        type="button"
                        className="btn-ligth-gray"
                        onClick={handleCloseModal}
                    >
                        <em className="fa fa-door-closed"></em> Fechar
                    </Button>
                </Modal.Footer>
            </ValidationForm>
        </Modal>
    );
}
